import {
  Button,
  DropdownItem as UnstyledDropdownItem,
  DropdownMenu as UnstyledDropdownMenu,
  DropdownToggle as UnstyledDropdownToggle
} from 'reactstrap';
import {
  sanJuan,
  tabButtonColor,
  tabButtonText
} from 'components/style/Colors.style';
import styled, { css } from 'styled-components';
import classNames from 'classnames';

export const LightTabButtonStyle = css`
  && {
    cursor: pointer;

    color: ${tabButtonText};
    background-color: ${tabButtonColor};
    border: none;

    font-size: 0.875rem;
    letter-spacing: 0.6px;
    text-align: left;

    height: 2rem;
    padding: 1px 16px;

    &.active {
      border: none;
      color: ${tabButtonColor};
      background-color: ${tabButtonText};
    }

    &&:focus {
      box-shadow: none;
    }
  }
`;

export const DarkTabButtonStyle = css`
  && {
    cursor: pointer;

    color: ${tabButtonColor};
    background-color: ${sanJuan};
    border: none;

    font-size: 14px;
    line-height: 2.29;
    letter-spacing: 0.6px;
    text-align: left;

    height: 2rem;
    padding: 1px 16px;

    &.active {
      border: none;
      color: ${sanJuan};
      background-color: ${tabButtonColor};
    }

    &&:focus {
      box-shadow: none;
    }
  }
`;

export const TabButton = styled(Button).attrs({
  className: ({ active }) => classNames({ active })
})`
  ${LightTabButtonStyle};
`;

export const DropdownToggle = styled(UnstyledDropdownToggle)`
  ${LightTabButtonStyle};
  font-weight: bold;
`;

export const DropdownMenu = styled(UnstyledDropdownMenu)`
  min-width: initial;
`;

export const DropdownToggleNarrowWhite = styled(UnstyledDropdownToggle)`
  color: #495566;
  background-color: white;
  border-color: #c4cdd5;
  padding: 0px 5px;
  font-size: 0.75rem;
`;

export const DropdownItem = styled(UnstyledDropdownItem)`
  &:active {
    color: ${tabButtonColor};
    background-color: ${tabButtonText};
  }
  &:focus {
    outline-color: ${tabButtonText};
  }
`;

export const SearchDropdownToggle = styled(UnstyledDropdownToggle)`
  ${LightTabButtonStyle};
  font-weight: bold;
  width: 160px;
  ::after {
    position: absolute;
    right: 10%
    top: 45%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/style/Buttons.style.js